import { ScrollArea } from "@/components/ui/scroll-area";
import { Checkbox } from "@/components/ui/checkbox";

interface RoutineSelectorProps {
  availableRoutines: any[];
  selectedRoutines: string[];
  onRoutineToggle: (routineId: string) => void;
}

export const RoutineSelector = ({ 
  availableRoutines, 
  selectedRoutines, 
  onRoutineToggle 
}: RoutineSelectorProps) => {
  if (!availableRoutines?.length) {
    return (
      <p className="text-white/70 text-center py-4">
        No hay rutinas disponibles para agregar al plan
      </p>
    );
  }

  return (
    <div className="bg-black/50 backdrop-blur-xl rounded-lg p-4">
      <h4 className="text-sm text-[#B4B4B4] font-heading mb-4">Selecciona las rutinas para este plan (opcional)</h4>
      <ScrollArea className="h-[200px] rounded-md border border-white/10 p-4">
        <div className="space-y-2">
          {availableRoutines.map((routine) => (
            <div
              key={routine.id}
              className="flex items-center space-x-2 p-2 rounded hover:bg-white/5"
            >
              <Checkbox
                id={routine.id}
                checked={selectedRoutines.includes(routine.id)}
                onCheckedChange={() => onRoutineToggle(routine.id)}
              />
              <label
                htmlFor={routine.id}
                className="text-sm text-white/70 font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
              >
                {routine.name}
              </label>
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};